import { useEffect, useState } from "react";

import HexagonInput from "@/common/customElements/HexagonInput";
import { InlineDiv } from "@/common/divs";
import { RegularText } from "@/common/texts";
import { ActivitiesRef, LanguageRef, LanguageType } from "@/types/components";
import { NEUTRO_PARAGRAPHS_COLOR } from "@/utils/constants";

interface LanguageContainerProps {
  language: LanguageType;
  languages: LanguageRef;
  valuesState: ActivitiesRef;
  deleteAll: boolean;
}

const LanguageContainer: React.FC<LanguageContainerProps> = ({
  language,
  languages,
  valuesState,
  deleteAll,
}) => {
  const [imSelected, setImSelected] = useState<boolean>(language.selected);
  useEffect(() => {
    if (deleteAll) {
      setImSelected(false);
    }
  }, [deleteAll]);
  const handleSelectLanguage = () => {
    setImSelected(!imSelected);
    const foundLanguage = languages.current.find(
      (languageToFind: LanguageContainerProps["language"]) =>
        languageToFind.id === language.id,
    );
    if (foundLanguage) {
      foundLanguage.selected = !foundLanguage.selected;
    }
    if (valuesState.current.languages) {
      const stringToArrayLanguages = valuesState.current?.languages.split(",");
      if (stringToArrayLanguages.includes(language.id.toString())) {
        stringToArrayLanguages.splice(
          stringToArrayLanguages.indexOf(language.id.toString()),
          1,
        );
        valuesState.current.languages = stringToArrayLanguages.toString();
      } else {
        stringToArrayLanguages.push(language.id.toString());
        valuesState.current.languages = stringToArrayLanguages.toString();
      }
    } else {
      valuesState.current.languages = [language.id].toString();
    }
    if (valuesState.current.languages == "") {
      delete valuesState.current.languages;
    }
  };

  return (
    <InlineDiv style={{ width: "fit-content" }}>
      <HexagonInput
        onClick={() => {
          handleSelectLanguage();
        }}
        checked={imSelected}
      />
      <RegularText
        fontSize="14px"
        style={{
          marginLeft: "5px",
          color: NEUTRO_PARAGRAPHS_COLOR,
        }}
      >
        {language.name}
      </RegularText>
    </InlineDiv>
  );
};

export default LanguageContainer;
